import { render, staticRenderFns } from "./trainingVideoList.vue?vue&type=template&id=4bb050e0&scoped=true&"
import script from "./trainingVideoList.vue?vue&type=script&lang=js&"
export * from "./trainingVideoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb050e0",
  null
  
)

export default component.exports